import { Injectable } from '@angular/core';
import { ConfigService } from '../config-service';

@Injectable({
  providedIn: 'root'
})

export class Utilities {

  baseAPIUrl=this.configService.baseAPIUrl;

  constructor(private configService: ConfigService) {
  }
  
  convertDate (date: Date) {
    let year = "" + date.getFullYear();
    let month = "" + (date.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
    let day = "" + date.getDate(); if (day.length == 1) { day = "0" + day; }
    return year + "-" + month + "-" + day;
  }

  getToken(){
   return sessionStorage.getItem("token")
  }
}
